export default "__VITE_ASSET__CN137Sx___"